import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { X, ArrowRight } from "lucide-react";
import { STORY } from "../mock";
import SpinningLogo from "./SpinningLogo";

const TruthPopup = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Show on every page load / refresh
    const t = setTimeout(() => setOpen(true), 900);
    const openNow = () => setOpen(true);
    window.addEventListener("open-truth", openNow);
    return () => { clearTimeout(t); window.removeEventListener("open-truth", openNow); };
  }, []);

  const close = () => {
    setOpen(false);
  };

  const goStory = () => {
    close();
    navigate("/our-story");
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-[#06160f]/80 backdrop-blur-sm" onClick={close} />
      <div className="relative w-full max-w-lg overflow-hidden rounded-3xl bg-white shadow-2xl pop-in">
        <div className="relative bg-gradient-to-br from-[#1B4332] to-[#2D6A4F] px-8 pt-10 pb-8 text-center text-white">
          <button
            onClick={close}
            aria-label="Close"
            className="absolute right-4 top-4 rounded-full bg-white/15 p-2 text-white transition hover:bg-white/30"
          >
            <X size={18} />
          </button>
          <div className="mx-auto mb-4 flex items-center justify-center">
            <SpinningLogo size={64} ring="ring-white/25" />
          </div>
          <p className="font-display text-sm uppercase tracking-[0.3em] text-[#95D5B2]">{STORY.popupTitle}</p>
          <h2 className="font-display mt-3 text-2xl font-700 font-bold uppercase leading-tight sm:text-3xl">
            {STORY.popupHeadline}
          </h2>
        </div>
        <div className="px-8 py-7 text-center">
          <p className="text-[15px] leading-relaxed text-[#3d4f46]">{STORY.popupBody}</p>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:justify-center">
            <button
              onClick={goStory}
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#2D6A4F] px-7 py-3 font-display text-sm font-semibold uppercase tracking-wider text-white transition hover:bg-[#1B4332]"
            >
              Read The Truth
              <ArrowRight size={16} className="transition group-hover:translate-x-1" />
            </button>
            <button
              onClick={() => { close(); navigate("/the-hidden-truth"); }}
              data-testid="truth-popup-hidden-truth-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#C62828] px-7 py-3 font-display text-sm font-semibold uppercase tracking-wider text-white transition-colors hover:bg-[#A31D1D]"
            >
              The Hidden Truth
            </button>
            <button
              onClick={close}
              className="rounded-full border border-[#cfe3d6] bg-white px-7 py-3 font-display text-sm font-semibold uppercase tracking-wider text-[#2D6A4F] transition hover:bg-[#f0f7f2]"
            >
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TruthPopup;
